export default __webpack_public_path__ + "static/media/gogle.0590aaf0.png";